var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.latitude && _vm.longitude)?_c('ymap-marker',{attrs:{"coords":[_vm.latitude, _vm.longitude],"marker-id":_vm.markerKey,"balloon-template":_vm.balloonTemplate,"icon":_vm.markerIcon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }